import styled from 'styled-components';

export default styled.div`
  max-width: 128rem;
  min-height: 100vh;

  margin: 0 auto;

  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.1);
`;
